

























































































































































































































































































import i18n from "@/i18n";
import Vue from "vue";
import VerifyBox from "@/components/app/VerifyBox.vue";
import { SubscriptionEditVueGB } from "@/extensions//subscription/SubscriptionEditVueGB";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: {
    VerifyBox,
    BackLink
  }
})
export default class SubscriptionEdit extends SubscriptionEditVueGB {
  mounted() {
    this.selectedCategory = null;
    if (this.$refs.subsForm) this.$refs.subsForm.resetValidation();
    // this.fillData(this.item);
    if (this.$route.query.openCategorySelect === 'true') {
      this.formMode = 'selectCategory';
    } else {
      this.setFormMode('createSubscription');
    }
  }

}

